import React from 'react';

const LeaveStats = ({ stats }) => {
    return (
        <div className='grid xl:grid-cols-4 lg:grid-cols-2 grid-cols-1 gap-15 mb-20'>
            <div className='bg-bg-dark rounded-lg shadow-light p-20'>
                <p className='text-text-secondary text-sm mb-2'>Total Requests</p>
                <p className='text-3xl font-bold'>{stats.total}</p>
            </div>
            <div className='bg-bg-dark rounded-lg shadow-light p-20'>
                <p className='text-text-secondary text-sm mb-2'>Pending</p>
                <p className='text-3xl font-bold text-warning'>{stats.pending}</p>
            </div>
            <div className='bg-bg-dark rounded-lg shadow-light p-20'>
                <p className='text-text-secondary text-sm mb-2'>Approved</p>
                <p className='text-3xl font-bold text-success'>{stats.approved}</p>
            </div>
            <div className='bg-bg-dark rounded-lg shadow-light p-20'>
                <p className='text-text-secondary text-sm mb-2'>Rejected</p>
                <p className='text-3xl font-bold text-danger'>{stats.rejected}</p>
            </div>
        </div>
    );
};

export default LeaveStats;
